export const headerOffset = () => (document.querySelector(".site-header")?.offsetHeight || 0) + 8;

export const scrollToId = (id, { instant = false } = {}) => {
  const el = document.getElementById(id);
  if (!el) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const top = id === "hem" ? 0 : el.getBoundingClientRect().top + window.scrollY - headerOffset();
  window.scrollTo({ top, behavior: instant || reduce ? "auto" : "smooth" });
};
